import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../../styles/GlobalStyle.css'
//import CustomFooter from '../../login/CustomFooter'
//import SubjectHistogram from '../../admin/SubjectHistogram'
//import SupportPieChartTiers from '../../admin/SupportPieChartTiers'
//import PersonAvatar from '../../customcomponents/PersonAvatar'
//import Empty from '../../customcomponents/Empty'
//import { getMathStandardsKindergarten, getMathUnits, getMathPrebuiltPacingGuideWeeks, getELAK } from './SCMath'
import { Layout, Select, Icon, Spin, Button, Alert, Menu, Radio, Tooltip, Input } from 'antd'
import PacingGuideAssessmentModalForm from './PacingGuideAssessmentModalForm'
import Empty from '../../customcomponents/Empty'
import ModalVideo from '../../customcomponents/ModalVideo'
import { KAssessment } from '../html/assessment/K.js'
import { FirstGradeAssessment } from '../html/assessment/1.js'
import { getPacingGuideWeekIndexDay } from '../../Util.js'
import PrintableAssessmentModal from './PrintableAssessmentModal.js'
//import { db } from '../../firebase/Firebase'
//import ColType from '../.././Types'
//import { flattenDoc, getStandardsColType, getstandardNamesDict } from '../../Util'
const Sider = Layout.Sider
const Content = Layout.Content
const RadioGroup = Radio.Group
// Friendly two-state status badge matching the dashboard: blue "Quiz Given" / yellow "Give Quiz".
function QuizStatusBadge({ given }) {
    return <span></span>;
    /*if (given) {
        return <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 14px', borderRadius: 999, backgroundColor: '#eff6ff', color: '#2563eb', fontWeight: 700, fontSize: 16, border: '1px solid #bfdbfe' }}><Icon type="check-circle" /> Quiz Given</span>
    }
    return <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 14px', borderRadius: 999, backgroundColor: '#fffbeb', color: '#d97706', fontWeight: 700, fontSize: 16, border: '1px solid #fde68a' }}><Icon type="edit" /> Give Quiz</span>
    */
}
class PacingGuideSC extends Component {
    state = {
        mathStandardsDict: {},
        mathIndividualStandardsDict: {},
        standards: [],
        prevStandardName: '',
        prevStandardCategory: '',
        standardName: 'Kindergarten',
        standardCategory: 'ELA',
        standardCategories: ['ELA', 'Math', 'Social Studies', 'Science'],
        gradeDictAcrossCategories: {
            'Kindergarten': 'K',
            '1st Grade': '1',
            '2nd Grade': '2',
            '3rd Grade': '3',
            '4th Grade': '4',
            '5th Grade': '5',
            '6th Grade': '6',
            '7th Grade': '7',
            '8th Grade': '8',
        },
        visible: false,
        assessmentVisible: false,
        lessonPlanStandardNames: ['ELA.1.F.3.6', 'ELA.3.AOR.6.1.a',
            'ELA.6.AOR.1.2', 'ELA.C.1', 'ELA.K.F.1.4', '2.ATO.1', '3.ATO.1',
            '4.ATO.4', '7.RP.2.d', 'A1.AAPR.1', 'K.NS.1', '3-ESS2-1',
            'B-LS1-5', 'USG.1.IP'],
        subjects: ['ELA', 'Math', 'Social Studies', 'Science'],
        lessonPlanStandardNamesSubjectDict: {
            'ELA': ['ELA.K.F.1.4', 'ELA.1.F.3.6', 'ELA.3.AOR.6.1.a',
                'ELA.6.AOR.1.2', 'ELA.C.1'],
            'Math': ['K.NS.1', '2.ATO.1', '3.ATO.1',
                '4.ATO.4', '7.RP.2.d', 'A1.AAPR.1'],
            'Social Studies': ['USG.1.IP'],
            'Science': ['3-ESS2-1', 'B-LS1-5'],
        },
        selectedStandardName: 'ELA.1.F.3.6',
        futureStandardsResourcesModalVisible: false,
        commonAssessmentTutorialModalVisible: false,
        quizTutorialModalVisible: false,
        k1CommonAssessmentModalVisible: false,
        commonAssessmentModalVisible: false,
        selectedQuarter: ['1'],
        searchQuery: '',
    }
    componentDidMount() {
        this.checkForQuarterElements();
    }
    componentWillUnmount() {
        if (this.quarterCheckInterval) {
            clearInterval(this.quarterCheckInterval);
        }
        clearTimeout(this.suppressQuarterTimeout);
        clearTimeout(this.restoreScrollTimeout);
        window.removeEventListener('scroll', this.handleScroll);
    }
    getSnapshotBeforeUpdate(prevProps, prevState) {
        const wasSearching = prevState.searchQuery.trim().length > 0
        const isSearching = this.state.searchQuery.trim().length > 0
        // Read scroll BEFORE the DOM swaps to the shorter search view — after the
        // swap the browser has already clamped scrollY and the value is wrong.
        if (!wasSearching && isSearching) {
            return { scrollY: window.scrollY, quarter: prevState.selectedQuarter }
        }
        return null
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const wasSearching = prevState.searchQuery.trim().length > 0
        const isSearching = this.state.searchQuery.trim().length > 0
        if (!wasSearching && isSearching) {
            // entering search: use the pre-mutation scroll/quarter captured above
            if (snapshot) {
                this.savedScrollY = snapshot.scrollY
                this.savedQuarter = snapshot.quarter
            }
            window.scrollTo({ top: 0 })
        } else if (wasSearching && !isSearching) {
            // closing search: rebuild the pacing guide, then jump back to the exact spot
            this.suppressQuarterUpdate = true
            const targetY = this.savedScrollY || 0
            this.setState(
                { selectedQuarter: this.savedQuarter || this.state.selectedQuarter },
                () => {
                    clearTimeout(this.restoreScrollTimeout)
                    this.restoreScrollTimeout = setTimeout(() => {
                        window.scrollTo({ top: targetY, behavior: 'auto' })
                        clearTimeout(this.suppressQuarterTimeout)
                        this.suppressQuarterTimeout = setTimeout(() => {
                            this.suppressQuarterUpdate = false
                        }, 250)
                    }, 1)
                }
            )
        }
    }
    checkForQuarterElements = () => {
        this.quarterCheckInterval = setInterval(() => {
            const quarterElements = [];
            for (let i = 1; i <= 4; i++) {
                const element = document.getElementById(`Quarter-${i}`);
                if (element) {
                    quarterElements.push(element);
                }
            }
            if (quarterElements.length === 4) {
                clearInterval(this.quarterCheckInterval);
                window.addEventListener('scroll', this.handleScroll);
                // Set initial quarter on load
                this.updateSelectedQuarter();
            }
        }, 100);
    }
    handleScroll = () => {
        if (this.suppressQuarterUpdate) return
        if (this.scrollTimeout) return
        this.scrollTimeout = setTimeout(() => {
            this.scrollTimeout = null;
            this.updateSelectedQuarter();
        }, 50);
    }
    updateSelectedQuarter = () => {
        const offset = 150;
        const quarters = [4, 3, 2, 1]; // Check in reverse order
        for (let quarter of quarters) {
            const element = document.getElementById(`Quarter-${quarter}`);
            if (element) {
                const rect = element.getBoundingClientRect();
                const elementTop = rect.top + window.scrollY;
                const currentScroll = window.scrollY + offset;
                if (currentScroll >= elementTop) {
                    if (this.state.selectedQuarter[0] !== quarter.toString()) {
                        this.setState({ selectedQuarter: [quarter.toString()] });
                    }
                    break;
                }
            }
        }
    }
    componentWillReceiveProps(nextProps) {
    }
    renderWelcomeBanner = () => {
        return <div style={{ display: 'flex', gap: 16, alignItems: 'center', background: '#f0f7ff', border: '1px solid #cfe3ff', borderRadius: 16, padding: '18px 22px', marginBottom: 22 }}>
            <Icon type='read' style={{ fontSize: 34, color: '#2d6a9f' }} />
            <div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', marginBottom: 2 }}>Welcome to your Pacing Guide</div>
                <div style={{ fontSize: 16, color: '#475569', lineHeight: 1.5 }}>Scroll down to see what to teach each week. Each standard is listed with its description. Click the blue <b>&ldquo;Click here to view the lesson&rdquo;</b> button on a standard to open its lesson, resources, and quizzes. Use the menu on the left to jump between quarters.</div>
            </div>
        </div>
    }
    showLessonPlanModal = (standard) => {
        this.setState({
            visible: true,
        })
    }
    onStandardNameChange = (value) => {
        if (this.props.pacingGuideBaseProps &&
            this.props.pacingGuideBaseProps.onStandardNameChangeFunc) {
            this.props.pacingGuideBaseProps.onStandardNameChangeFunc(value)
        }
    }
    onStandardCategoryChange = (value) => {
        if (this.props.pacingGuideBaseProps &&
            this.props.pacingGuideBaseProps.onStandardCategoryChangeFunc) {
            this.props.pacingGuideBaseProps.onStandardCategoryChangeFunc(value)
        }
    }
    displayPacingGuideBeingCreatedNotificationIfNeeded = () => {
        if (this.props.teacherBaseProps &&
            this.props.teacherBaseProps.hasOwnProperty('districtSettings') &&
            this.props.teacherBaseProps.districtSettings &&
            this.props.teacherBaseProps.districtSettings.hasOwnProperty('pacingGuideBeingCreated') &&
            this.props.teacherBaseProps.districtSettings.pacingGuideBeingCreated) {
            return <div className='mb-3'>
                <Alert
                    type='info'
                    className='p-3 br-4'
                    message={<div className='font-20 font-bold'>Pacing Guide</div>}
                    description={<div className='font-20'>
                        Your pacing guide is currently being created.
                    </div>
                    }
                />
            </div>
        }
        return ''
    }
    getWeeks = (pacingGuide, futurePacingGuide) => {
        if (futurePacingGuide) {
            return futurePacingGuide.weeks
        } else if (pacingGuide) {
            return pacingGuide.weeks
        }
        return {}
    }
    pacingGuideIsEmpty = (pacingGuide) => {
        if (!pacingGuide) {
            return true
        }
        if (pacingGuide &&
            pacingGuide.weeks) {
            for (let week in pacingGuide.weeks) {
                // skip week 0
                if (week === '0') {
                    continue
                }
                if (pacingGuide.weeks[week].length > 0) {
                    return false
                }
            }
        }
        return true
    }
    setupQuarterObserver = () => {
        const options = {
            root: null, // viewport
            rootMargin: '-100px 0px 0px 0px', // Account for your offset
            threshold: 0.1 // Trigger when 10% of element is visible
        };
        this.quarterObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Extract quarter number from element id
                    const quarterId = entry.target.id.split('-')[1];
                    this.setState({ selectedQuarter: [quarterId] });
                }
            });
        }, options);
        // Observe all quarter elements
        for (let i = 1; i <= 4; i++) {
            const element = document.getElementById(`Quarter-${i}`);
            if (element) {
                this.quarterObserver.observe(element);
            }
        }
    }
    // Renders a single standard for a week as an easy-to-read vertical card.
    // The connective framing for a week, shown above its standard cards.
    //
    // Returns nothing at all unless a matching document was loaded. Weeks with
    // a single standard have none by design, districts may have none generated,
    // and the read may have failed - all three look the same here, which is
    // deliberate: this is supplementary content and its absence is normal.
    renderWeekConnection = (weekNumber) => {
        const p = this.props.pacingGuideBaseProps
        if (!p || !p.weekConnectionKeys || !p.weekConnectionsDict) {
            return ''
        }
        const contentKey = p.weekConnectionKeys[weekNumber]
        if (!contentKey) {
            return ''
        }
        const connection = p.weekConnectionsDict[contentKey]
        if (!connection || !connection.throughline) {
            return ''
        }

        const bridges = Array.isArray(connection.bridges) ? connection.bridges : []

        return <div style={{
            background: '#f0f7ff', border: '1px solid #cfe3ff', borderRadius: 16,
            padding: '16px 20px', marginBottom: 14,
        }}>
            <div className='flex flex-v-center' style={{ gap: 8, marginBottom: 8 }}>
                <Icon type='compass' style={{ fontSize: 20, color: '#2d6a9f' }} />
                <div style={{ fontSize: 15, fontWeight: 800, color: '#2d6a9f', letterSpacing: 0.4 }}>
                    HOW THIS WEEK FITS TOGETHER
                </div>
            </div>
            <div style={{ fontSize: 17, color: '#1e293b', lineHeight: 1.55, marginBottom: 8 }}>
                {connection.throughline}
            </div>
            {connection.guidingQuestion ?
                <div style={{ fontSize: 16, color: '#475569', fontStyle: 'italic', marginBottom: 4 }}>
                    {connection.guidingQuestion}
                </div> : ''}

            <div style={{ marginTop: 12 }}>
                {bridges.map((bridge, i) => {
                    return <div key={'bridge-' + i} style={{ marginBottom: 10 }}>
                        <div style={{ fontSize: 16, fontWeight: 700, color: '#1e293b' }}>
                            {bridge.label}
                        </div>
                        <div style={{ fontSize: 16, color: '#334155', lineHeight: 1.5 }}>
                            {bridge.text}
                        </div>
                    </div>
                })}
                {/* A week whose standards do not connect carries a short
                    note instead of bridges. */}
                {bridges.length === 0 && connection.connectionNote ?
                    <div style={{ fontSize: 16, color: '#334155', lineHeight: 1.5, marginBottom: 10 }}>
                        {connection.connectionNote}
                    </div> : ''}
                {connection.culminatingTask ?
                    <div style={{ marginTop: 4 }}>
                        <div style={{ fontSize: 16, fontWeight: 700, color: '#1e293b' }}>
                            Bringing it together
                        </div>
                        <div style={{ fontSize: 16, color: '#334155', lineHeight: 1.5 }}>
                            {connection.culminatingTask}
                        </div>
                    </div> : ''}
            </div>
        </div>
    }

    renderStandardCard = (item, weekNumber, ind, index, weekNumForQuarter, isCurrentYear) => {
        const p = this.props.pacingGuideBaseProps
        const currentWeek = p.currentWeek
        const isFuture = Number(weekNumber) > currentWeek
        const isCurrentWeek = currentWeek === weekNumber
        const sp = (p.standardsProgress && p.standardsProgress.hasOwnProperty(item.standard)) ? p.standardsProgress[item.standard] : null
        // Decide whether the quiz for this standard has been given.
        let quizGiven = false
        if (p.pacingGuideStats && p.standardCategory && p.standardName) {
            const stats = p.pacingGuideStats
            const cat = p.standardCategory
            const name = p.standardName
            const weekData = stats.guides && stats.guides[cat] && stats.guides[cat][name] && stats.guides[cat][name][String(weekNumber)]
            if (weekData) {
                const entry = weekData.find(e => e.standard === item.standard)
                if (entry && (entry.action === 'reteach' || entry.action === 'review' || entry.action === 'on_track')) {
                    quizGiven = true
                }
            }
        }
        if (!quizGiven && sp && ((sp.quizzesCompletedPct || 0) > 0 || (sp.quizzesAverageScore || 0) > 0)) {
            quizGiven = true
        }
        const lessonPlanQueryString = '?standardName=' + item.standardName + '&standard=' + item.standard + '&category=' + item.standardCategory + '&week=' + weekNumForQuarter + '&index=' + index
        return <div key={ind + '-' + index} style={{ background: '#fff', border: isCurrentWeek ? '2px solid #3b82f6' : '1px solid #e8eef5', borderRadius: 16, padding: '18px 20px', marginBottom: 14, boxShadow: 'rgba(100, 100, 111, 0.12) 0px 4px 14px 0px' }}>            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
            <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b' }}>{item.standard}</div>
            {item.isPriority ?
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: '#722ed1', color: '#fff', borderRadius: 999, padding: '4px 12px', fontSize: 14, fontWeight: 700 }}><Icon type='pushpin' /> Priority</span>
                : ''}
            <div style={{ marginLeft: 'auto' }}>
                {isFuture ?
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#f1f5f9', color: '#64748b', borderRadius: 999, padding: '6px 14px', fontSize: 16, fontWeight: 700, border: '1px solid #e2e8f0' }}><Icon type='clock-circle' /> Upcoming</span>
                    : <QuizStatusBadge given={quizGiven} />}
            </div>
        </div>
            <div style={{ fontSize: 17, color: '#334155', lineHeight: 1.5 }}>{item.title}</div>
            {!isFuture && quizGiven && sp ?
                <div style={{ marginTop: 12, padding: '10px 14px', background: '#f0f7ff', border: '1px solid #cfe3ff', borderRadius: 12, fontSize: 16, color: '#334155' }}>
                    <div>Students finished: {Math.round((sp.totalCompletedPct || 0) * 100)}%</div>
                    <div>Average quiz score: {Math.round((sp.quizzesAverageScore || 0) * 100)}%</div>
                </div>
                : ''}
            {!(!isCurrentYear ||
                (p.pacingGuideMode === 'future' && p.futurePacingGuide)) ?
                <Link to={this.props.teacherBaseProps &&
                    this.props.teacherBaseProps.teacher ?
                    '/teacher/pacing-guide/lesson-plan/' + this.props.teacherBaseProps.teacher.id + lessonPlanQueryString
                    :
                    this.props.teacherBaseProps &&
                        this.props.teacherBaseProps.admin ?
                        '/admin/pacing-guide/lesson-plan/' + this.props.teacherBaseProps.admin.id + lessonPlanQueryString
                        :
                        this.props.teacherBaseProps &&
                            this.props.teacherBaseProps.instructionalFacilitator ?
                            '/instructional-facilitator/pacing-guide/lesson-plan/' + this.props.teacherBaseProps.instructionalFacilitator.id + lessonPlanQueryString
                            :
                            this.props.teacherBaseProps &&
                                this.props.teacherBaseProps.schoolAdmin ?
                                '/school-admin/pacing-guide/lesson-plan/' + this.props.teacherBaseProps.schoolAdmin.id + lessonPlanQueryString
                                :
                                ''}
                    size='large'
                    style={{ width: '100%', height: 'auto', padding: '12px 16px', marginTop: 14 }}
                    className={'ant-btn ant-btn-lg ant-btn-primary flex flex-v-center flex-h-center font-18 font-bold'}>
                    <Icon type='solution' className='mr-1 font-24' />
                    <span>Click here to view the lesson</span>
                </Link>
                : ''}
        </div>
    }

    // Simple fuzzy matcher: returns a score (higher = better) or -1 for no match.
    // Exact substring matches rank highest; otherwise an in-order subsequence
    // match that rewards consecutive characters.
    fuzzyScore = (query, text) => {
        query = (query || '').toLowerCase().trim()
        text = (text || '').toLowerCase()
        if (!query) return 0
        if (!text) return -1
        const idx = text.indexOf(query)
        if (idx !== -1) {
            // earlier and tighter matches score higher
            return 1000 - idx - (text.length - query.length) * 0.1
        }
        let ti = 0
        let score = 0
        let consecutive = 0
        let prevMatchIdx = -1
        for (let qi = 0; qi < query.length; qi++) {
            const qc = query[qi]
            let found = false
            while (ti < text.length) {
                if (text[ti] === qc) {
                    found = true
                    if (prevMatchIdx !== -1 && prevMatchIdx === ti - 1) {
                        consecutive++
                        score += 5 + consecutive
                    } else {
                        consecutive = 0
                        score += 1
                    }
                    prevMatchIdx = ti
                    ti++
                    break
                }
                ti++
            }
            if (!found) return -1
        }
        return score
    }

    getAllStandards = () => {
        const p = this.props.pacingGuideBaseProps
        if (!p || !p.weekNums) return []
        let pacingGuide = p.pacingGuide
        if (p.pacingGuideMode === 'future' && p.futurePacingGuide) {
            pacingGuide = p.futurePacingGuide
        }
        if (!pacingGuide || !pacingGuide.weeks) return []

        // cache keyed on the exact guide object + mode we flattened
        if (this._allStandardsCache &&
            this._allStandardsCacheKey === pacingGuide &&
            this._allStandardsCacheMode === p.pacingGuideMode) {
            return this._allStandardsCache
        }

        const results = []
        p.weekNums.forEach((weekNumber, ind) => {
            if (ind === 0) return
            if (!pacingGuide.weeks.hasOwnProperty(weekNumber)) return
            const week = pacingGuide.weeks[weekNumber]
            if (!week) return
            const quarter = Math.ceil(ind / 9)
            let weekNumForQuarter = ind % 9
            if (weekNumForQuarter === 0) weekNumForQuarter = 9
            week.forEach((item, index) => {
                results.push({ item, weekNumber, ind, index, weekNumForQuarter, quarter })
            })
        })

        this._allStandardsCache = results
        this._allStandardsCacheKey = pacingGuide
        this._allStandardsCacheMode = p.pacingGuideMode
        return results
    }

    getSearchResults = () => {
        const query = (this.state.searchQuery || '').trim()
        if (!query) return []
        const scored = []
        this.getAllStandards().forEach((entry) => {
            const item = entry.item
            const score = Math.max(
                this.fuzzyScore(query, item.standard),
                this.fuzzyScore(query, item.title)
            )
            if (score > 0) {
                scored.push(Object.assign({}, entry, { score }))
            }
        })
        scored.sort((a, b) => b.score - a.score)
        // one card per standard: keep the first (best-scoring) occurrence
        const seen = {}
        const deduped = []
        scored.forEach((r) => {
            if (seen[r.item.standard]) return
            seen[r.item.standard] = true
            deduped.push(r)
        })
        return deduped
    }

    renderSearchBar = () => {
        return <div
            className='pacing-guide-search'
            style={{
                position: 'fixed',
                top: 85,
                zIndex: 1000,
                background: '#fff',
                paddingTop: 14,
                paddingBottom: 14,
                paddingLeft: 16,
                paddingRight: 16,
                marginLeft: -16,
                width: 828,
                borderRadius: 20,
                boxShadow: '0 6px 18px rgba(30, 58, 95, 0.10)',
            }}>
            <style>{`
            .pacing-guide-search .ant-input-affix-wrapper .ant-input-prefix { left: 20px; }
            .pacing-guide-search .ant-input-affix-wrapper input {
                font-size: 18px !important;
                height: 52px !important;
                padding-left: 52px !important;
                border-radius: 100px !important;
                border: 2px solid #cfe3ff !important;          /* thicker, tinted border */
                background: #f5f9ff !important;                /* subtle blue tint vs. plain white */
                box-shadow: 0 2px 8px rgba(45, 106, 159, 0.08) !important;
                transition: all 0.15s ease !important;
            }
            .pacing-guide-search .ant-input-affix-wrapper input:hover {
                border-color: #7fb0e0 !important;
                background: #fff !important;
            }
            .pacing-guide-search .ant-input-affix-wrapper input:focus {
                border-color: #2d6a9f !important;
                background: #fff !important;
                box-shadow: 0 0 0 4px rgba(45, 106, 159, 0.15) !important;  /* focus glow */
            }
            
            .pacing-guide-search .ant-input-affix-wrapper input::placeholder {
                color: #94a3b8 !important;
                opacity: 1 !important;
            }
        `}</style>
            <Input
                size='large'
                allowClear
                placeholder='Search by standard or standard description...'
                value={this.state.searchQuery}
                onChange={(e) => this.setState({ searchQuery: e.target.value })}
                prefix={<Icon type='search' style={{ color: '#2d6a9f', fontSize: 20 }} />}
            />
        </div>
    }

    renderSearchResults = (isCurrentYear) => {
        const results = this.getSearchResults()
        return <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, marginBottom: 20, flexWrap: 'wrap' }}>
                <div style={{ fontSize: 24, fontWeight: 800, color: '#1e293b' }}>
                    {results.length} {results.length === 1 ? 'result' : 'results'} for &ldquo;{this.state.searchQuery.trim()}&rdquo;
                </div>
                <Button
                    size='large'
                    type='primary'
                    onClick={() => this.setState({ searchQuery: '' })}
                    style={{ height: 'auto', padding: '12px 22px', fontSize: 17, fontWeight: 700, borderRadius: 12, display: 'inline-flex', alignItems: 'center', gap: 8 }}
                >
                    <Icon type='close' className='font-20' />
                    <span>Close search &amp; return to pacing guide</span>
                </Button>
            </div>
            {results.length === 0 ?
                <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                    <Icon type='search' style={{ fontSize: 48, color: '#cbd5e1' }} />
                    <div style={{ fontSize: 20, fontWeight: 700, color: '#475569', marginTop: 16 }}>No standards found</div>
                    <div style={{ fontSize: 16, color: '#94a3b8', marginTop: 6 }}>Try a different code or keyword.</div>
                </div>
                :
                results.map((r) => {
                    return <div key={'search-' + r.ind + '-' + r.index}>
                        <div style={{ fontSize: 13, fontWeight: 700, color: '#2d6a9f', letterSpacing: 0.4, textTransform: 'uppercase', marginBottom: 6 }}>
                            Quarter {r.quarter}, Week {r.weekNumForQuarter}
                        </div>
                        {this.renderStandardCard(r.item, r.weekNumber, r.ind, r.index, r.weekNumForQuarter, isCurrentYear)}
                    </div>
                })}
        </div>
    }


    render() {
        let standardDisplayName = ''
        let isCurrentYear = true
        if (this.props.pacingGuideBaseProps &&
            this.props.pacingGuideBaseProps.standardNamesDict &&
            this.props.pacingGuideBaseProps.standardCategory &&
            this.props.pacingGuideBaseProps.standardName &&
            this.props.pacingGuideBaseProps.standardNamesDict.hasOwnProperty(this.props.pacingGuideBaseProps.standardCategory + 'DisplayNames') &&
            this.props.pacingGuideBaseProps.standardNamesDict[this.props.pacingGuideBaseProps.standardCategory + 'DisplayNames'].hasOwnProperty(this.props.pacingGuideBaseProps.standardName)) {
            standardDisplayName = this.props.pacingGuideBaseProps.standardNamesDict[this.props.pacingGuideBaseProps.standardCategory + 'DisplayNames'][this.props.pacingGuideBaseProps.standardName]
        }
        if (this.props.pacingGuideBaseProps &&
            this.props.pacingGuideBaseProps.activeYear &&
            this.props.pacingGuideBaseProps.standardYears &&
            this.props.pacingGuideBaseProps.standardYears.currentYear) {
            // viewing a previous pacing guide
            isCurrentYear = this.props.pacingGuideBaseProps.activeYear === this.props.pacingGuideBaseProps.standardYears.currentYear
        }

        return (
            <div>
                {this.props.pacingGuideBaseProps ?
                    <Layout className="layout-header-mt mt-0 min-w-1024">
                        <Sider
                            width={270}
                            style={{
                                overflow: 'auto', overflowX: 'hidden', height: 'calc(100% - 82px)',
                                position: 'fixed',
                                left: 0, marginTop: '82px', borderRight: '1px solid #f1f1f1',
                                background: '#fff', borderTop: '1px solid #f1f1f1', fontSize: 16
                            }}>
                            {this.props.pacingGuideBaseProps.initialized ?
                                <div>
                                    <div className='pl-2 pr-2 mb-2 mt-3'>
                                        <Select onChange={this.onStandardCategoryChange} value={this.props.pacingGuideBaseProps.standardCategory} size='large' className='w-100 mb-1' >
                                            {this.props.pacingGuideBaseProps.standardCategories.map((category, ind) => {
                                                return <Select.Option key={'category-' + ind} value={category}>{category}</Select.Option>
                                            })}
                                        </Select>
                                        <Select onChange={this.onStandardNameChange} value={this.props.pacingGuideBaseProps.standardName} size='large' className='w-100'>
                                            {this.props.pacingGuideBaseProps.pacingGuideMode === 'current' &&
                                                this.props.pacingGuideBaseProps.standardNamesDict &&
                                                this.props.pacingGuideBaseProps.standardNamesDict.hasOwnProperty(this.props.pacingGuideBaseProps.standardCategory) &&
                                                this.props.pacingGuideBaseProps.standardNamesDict[this.props.pacingGuideBaseProps.standardCategory].map((standardName, ind) => {
                                                    return <Select.Option key={'grade-' + ind} value={standardName}>{standardName}</Select.Option>
                                                })}
                                            {this.props.pacingGuideBaseProps.pacingGuideMode === 'future' &&
                                                this.props.pacingGuideBaseProps.standardNamesDict &&
                                                this.props.pacingGuideBaseProps.standardNamesDict.hasOwnProperty('Future' + this.props.pacingGuideBaseProps.standardCategory) &&
                                                this.props.pacingGuideBaseProps.standardNamesDict['Future' + this.props.pacingGuideBaseProps.standardCategory] &&
                                                this.props.pacingGuideBaseProps.standardNamesDict['Future' + this.props.pacingGuideBaseProps.standardCategory].map((standardName, ind) => {
                                                    return <Select.Option key={'grade-' + ind} value={standardName}>
                                                        Next year: {standardName}
                                                    </Select.Option>
                                                })}
                                        </Select>
                                        {/*this.props.teacherBaseProps &&
                                            this.props.teacherBaseProps.hasOwnProperty('admin') &&
                                            this.props.teacherBaseProps.admin &&
                                            this.props.teacherBaseProps.schools ?
                                            <Tooltip
                                                overlayClassName='pointer-events-none-important'
                                                mouseEnterDelay={0.5}
                                                title={'View standards progress for the entire district or for each school in the district.'}>
                                                <Select
                                                    onChange={(e) => {
                                                        if (this.props.pacingGuideBaseProps &&
                                                            this.props.pacingGuideBaseProps.setActiveSchoolFunc) {
                                                            this.props.pacingGuideBaseProps.setActiveSchoolFunc(e)
                                                        }
                                                    }}
                                                    value={this.props.pacingGuideBaseProps.activeSchoolId} size='large' className='w-100 mt-1'>
                                                    {['district'].concat(this.props.teacherBaseProps.schools).map((school, ind) => {
                                                        let name = school === 'district' ? 'District' : school.schoolName
                                                        let id = school === 'district' ? 'district' : school.id
                                                        let titleString = school === 'district' ?
                                                            'View standards progress for the entire district.' :
                                                            'View standards progress for ' + school.schoolName + '.'
                                                        return <Select.Option key={'school-' + id} value={id} title={titleString}>{name}</Select.Option>
                                                    })}
                                                </Select>
                                            </Tooltip>
                                            : ''*/}
                                        {/*this.props.teacherBaseProps &&
                                            this.props.teacherBaseProps.hasOwnProperty('instructionalFacilitator') &&
                                            this.props.teacherBaseProps.instructionalFacilitator &&
                                            this.props.teacherBaseProps.schools ?
                                            <Tooltip
                                                overlayClassName='pointer-events-none-important'
                                                mouseEnterDelay={0.5}
                                                title={'View standards progress for schools in the district.'}>
                                                <Select onChange={(e) => {
                                                    if (this.props.pacingGuideBaseProps &&
                                                        this.props.pacingGuideBaseProps.setActiveSchoolFunc) {
                                                        this.props.pacingGuideBaseProps.setActiveSchoolFunc(e)
                                                    }
                                                }}
                                                    value={this.props.pacingGuideBaseProps.activeSchoolId} size='large' className='w-100 mt-1'>
                                                    {this.props.teacherBaseProps.schools.map((school, ind) => {
                                                        let titleString = 'View standards progress for ' + school.schoolName + '.'
                                                        return <Select.Option key={'school-' + school.id} value={school.id} title={titleString}>{school.schoolName}</Select.Option>
                                                    })}
                                                </Select>
                                            </Tooltip>
                                            : ''*/}
                                        {/*this.props.teacherBaseProps &&
                                            !this.props.teacherBaseProps.hasOwnProperty('teacher') &&
                                            this.props.teacherBaseProps.hasOwnProperty('districtSettings') &&
                                            this.props.teacherBaseProps.districtSettings &&
                                            this.props.teacherBaseProps.districtSettings.hasOwnProperty('pacingGuideYears') &&
                                            this.props.teacherBaseProps.districtSettings.pacingGuideYears &&
                                            this.props.teacherBaseProps.districtSettings.pacingGuideYears.length > 1 ?
                                            <Select onChange={(e) => {
                                                if (this.props.pacingGuideBaseProps &&
                                                    this.props.pacingGuideBaseProps.onSetActiveYearFunc) {
                                                    this.props.pacingGuideBaseProps.onSetActiveYearFunc(e)
                                                }
                                            }}
                                                value={this.props.pacingGuideBaseProps.activeYear}
                                                size='large' className='w-100 mt-1'>
                                                {this.props.teacherBaseProps.districtSettings.pacingGuideYears.sort((a, b) => {
                                                    return b - a
                                                }).map((year, ind) => {
                                                    let yearAsInt = parseInt(year, 10)
                                                    return <Select.Option key={'year-' + ind} value={year}>{year + '-' + (yearAsInt + 1)}</Select.Option>
                                                })}
                                            </Select> : ''*/}
                                        {this.props.pacingGuideBaseProps.futurePacingGuide ?
                                            <div className='w-100 mt-2'>
                                                <RadioGroup size='large' onChange={(e) => {
                                                    if (this.props.pacingGuideBaseProps &&
                                                        this.props.pacingGuideBaseProps.onSetPacingGuideMode) {
                                                        this.props.pacingGuideBaseProps.onSetPacingGuideMode(e.target.value)
                                                    }
                                                }}
                                                    value={this.props.pacingGuideBaseProps.pacingGuideMode} className='mt-1'>
                                                    <Radio.Button value={'current'} className='font-16 w-100'>Current Pacing Guide</Radio.Button>
                                                    <Radio.Button value={'future'} className='font-16 w-100'>Next Year's Standards</Radio.Button>
                                                </RadioGroup>
                                                {this.props.pacingGuideBaseProps.pacingGuideMode === 'future' ?
                                                    <a href={`https://ed.sc.gov/instruction/standards/mathematics/instructional-resources/content-shifts-potential-gaps-for-math-standards-implementation/#${encodeURIComponent(this.props.pacingGuideBaseProps.standardName)}`}
                                                        target='_blank' rel='noopener noreferrer'
                                                        className='ant-btn ant-btn-primary ant-btn-lg w-100 mb-2 mt-3'>
                                                        View Content Shifts
                                                        <Icon type='arrow-right' className='ml-1' />
                                                    </a> : ''}
                                            </div>
                                            : ''}
                                    </div>
                                    <Menu
                                        style={{ fontSize: 16 }}
                                        onSelect={(e) => {
                                            // Update selected keys in state
                                            this.setState({ selectedQuarter: [e.key] });
                                            // Scroll to element
                                            const element = document.getElementById('Quarter-' + e.key)
                                            if (element) {
                                                const offset = 100;
                                                const elementPosition = element.getBoundingClientRect().top + window.scrollY - offset;
                                                window.scrollTo({
                                                    top: elementPosition,
                                                })
                                            }
                                        }}
                                        selectedKeys={this.state.selectedQuarter}
                                    >
                                        <Menu.Item key="1">
                                            <div className='font-16'>Quarter 1</div>
                                        </Menu.Item>
                                        <Menu.Item key="2">
                                            <div className='font-16'>Quarter 2</div>
                                        </Menu.Item>
                                        <Menu.Item key="3">
                                            <div className='font-16'>Quarter 3</div>
                                        </Menu.Item>
                                        <Menu.Item key="4">
                                            <div className='font-16'>Quarter 4</div>
                                        </Menu.Item>
                                    </Menu>
                                    {this.props.pacingGuideBaseProps &&
                                        this.props.pacingGuideBaseProps.pacingGuidePDFURL !== '' ?
                                        <div className='mt-3'>
                                            <a
                                                href={this.props.pacingGuideBaseProps.pacingGuidePDFURL}
                                                target='_blank'
                                                rel='noopener noreferrer'
                                                className={'ant-btn ant-btn-primary ant-btn-lg inline-flex ml-1'}
                                            >
                                                <Icon type='file-pdf' className='font-20 mr-1 mt-1' />
                                                {this.props.pacingGuideBaseProps &&
                                                    this.props.pacingGuideBaseProps.pacingGuidePDFURLLoading ?
                                                    <div style={{ width: '216px' }}>
                                                        <Spin className='fff-spin' />
                                                    </div> :
                                                    <div>{'View Pacing Guide PDF'}</div>}
                                            </a>
                                        </div> : ''}
                                </div> : ''}
                        </Sider>
                        <Layout className="content">
                            {this.props.pacingGuideBaseProps.initialized ?
                                <Content
                                    style={{
                                        marginLeft: 270, marginTop: "98px", overflowX: 'initial'
                                    }}
                                    className={'p-2 pl-4 pr-4' + (this.props.pacingGuideBaseProps &&
                                        this.props.pacingGuideBaseProps.currentWeek < 0 ? ' invisible' : ''
                                    )}
                                    id="pacing-guide-content"
                                >

                                    <div
                                        className='pb-2 pl-4 pr-4'
                                        style={{ maxWidth: 860, margin: '0 auto', paddingTop: 80 }}>
                                        {this.renderSearchBar()}
                                        {this.state.searchQuery.trim() ?
                                            this.renderSearchResults(isCurrentYear)
                                            :
                                            <div>
                                                {this.displayPacingGuideBeingCreatedNotificationIfNeeded()}
                                                {this.renderWelcomeBanner()}
                                                <ModalVideo
                                                    title='Common Assessments'
                                                    visible={this.state.k1CommonAssessmentModalVisible}
                                                    onOk={() => {
                                                        this.setState({
                                                            k1CommonAssessmentModalVisible: false,
                                                        })
                                                    }}
                                                    onCancel={() => {
                                                        this.setState({
                                                            k1CommonAssessmentModalVisible: false,
                                                        })
                                                    }}
                                                    width={888}
                                                    src={'https://firebasestorage.googleapis.com/v0/b/education-9d7f3.appspot.com/o/k1_assessment_2025.mp4?alt=media&token=08130a7e-f417-4bc3-89c8-3ba657fef315'}
                                                    className='p-0'
                                                />
                                                <ModalVideo
                                                    title='Common Assessments'
                                                    visible={this.state.commonAssessmentModalVisible}
                                                    onOk={() => {
                                                        this.setState({
                                                            commonAssessmentModalVisible: false,
                                                        })
                                                    }}
                                                    onCancel={() => {
                                                        this.setState({
                                                            commonAssessmentModalVisible: false,
                                                        })
                                                    }}
                                                    width={888}
                                                    src={'https://firebasestorage.googleapis.com/v0/b/education-9d7f3.appspot.com/o/general_assessment_2025.mp4?alt=media&token=a56a80ce-fec7-4f00-9d8a-86cc5931dc5c'}
                                                    className='p-0'
                                                />
                                                {this.props.pacingGuideBaseProps.pacingGuideMode === 'future' &&
                                                    this.props.pacingGuideBaseProps.futurePacingGuide ?
                                                    <div>
                                                        <div className='font-24 mb-2 p-2 background-lighter-blue br-4'>This is an example pacing guide to preview next year's standards.</div>
                                                    </div>
                                                    : ''}
                                                <div className='br-20 overflow-hidden' id={'Quarter-' + 1}>
                                                    <div className='br-4 relative pl-3 pr-3 pt-3 relative'
                                                        style={{ height: '280px', }}>
                                                        <div className="absolute-tl w-100 h-100" style={{ background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)' }}>
                                                        </div>
                                                        <div className="absolute-tl w-100 h-100"
                                                        >
                                                        </div>
                                                        <div className='absolute-tl w-100 h-100'>
                                                            <div className='h-100'>
                                                                <div className='flex flex-v-center font-40 font-fff h-100 p-4'>
                                                                    <div>
                                                                        <div className='font-40 font-bold font-fff'>Standards First Pacing Guide</div>
                                                                        <div className='font-24 font-fff font-bold'>{standardDisplayName ? standardDisplayName : ''}</div>
                                                                        <div>
                                                                            <div className='font-24 p-2 pt-1 pb-1 br-4 mt-1 inline-block'
                                                                                style={{ background: '#3fa672' }}
                                                                            ><span>{'Quarter 1'}</span></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.props.pacingGuideBaseProps.weekNums &&
                                                    this.props.pacingGuideBaseProps.weekNums.map((weekNumber, ind) => {
                                                        if (ind === 0) {
                                                            return false
                                                        }
                                                        let week = null
                                                        if (this.props.pacingGuideBaseProps.pacingGuide) {
                                                            if (!this.props.pacingGuideBaseProps.pacingGuide.weeks.hasOwnProperty(weekNumber)) {
                                                                return false
                                                            }
                                                            week = this.props.pacingGuideBaseProps.pacingGuide.weeks[weekNumber]
                                                        }
                                                        if (this.props.pacingGuideBaseProps.pacingGuideMode === 'future' &&
                                                            this.props.pacingGuideBaseProps.futurePacingGuide) {
                                                            if (!this.props.pacingGuideBaseProps.futurePacingGuide.weeks.hasOwnProperty(weekNumber)) {
                                                                return false
                                                            }
                                                            week = this.props.pacingGuideBaseProps.futurePacingGuide.weeks[weekNumber]
                                                        }
                                                        if (!week) {
                                                            return false
                                                        }
                                                        // every 9 weeks
                                                        let quarter = Math.ceil(ind / 9);
                                                        let showQuarter = ind === 1 || ind === 10 || ind === 19 || ind === 28
                                                        let weekNumForQuarter = ind % 9
                                                        if (weekNumForQuarter === 0) {
                                                            weekNumForQuarter = 9
                                                        }
                                                        let isBenchmark = false
                                                        if (this.props.pacingGuideBaseProps &&
                                                            this.props.pacingGuideBaseProps.assessmentsWeekDict &&
                                                            this.props.pacingGuideBaseProps.assessmentsWeekDict.hasOwnProperty(weekNumber) &&
                                                            this.props.pacingGuideBaseProps.assessmentsWeekDict[weekNumber].assessments &&
                                                            this.props.pacingGuideBaseProps.assessmentsWeekDict[weekNumber].assessments.length > 0) {
                                                            let firstAssessment = this.props.pacingGuideBaseProps.assessmentsWeekDict[weekNumber].assessments[0]
                                                            isBenchmark = firstAssessment.assessmentCategory === 'benchmark'
                                                        }
                                                        let backgroundColor = '#faa916'
                                                        if (quarter === 3) {
                                                            backgroundColor = '#722ed1'
                                                        } else if (quarter === 4) {
                                                            backgroundColor = '#1098f7'
                                                        }
                                                        return <div key={'weekNum-' + ind}>
                                                            {showQuarter && quarter !== 1 ?
                                                                <div className='br-20 overflow-hidden' id={'Quarter-' + quarter}>
                                                                    <div className='br-4 relative pl-3 pr-3 pt-3 relative'
                                                                        style={{ height: '280px', }}>
                                                                        <div className="absolute-tl w-100 h-100" style={{ background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)' }}>
                                                                        </div>
                                                                        <div className="absolute-tl w-100 h-100"
                                                                        >
                                                                        </div>
                                                                        <div className='absolute-tl w-100 h-100'>
                                                                            <div className='h-100'>
                                                                                <div className='flex flex-v-center font-40 font-fff h-100 p-4'>
                                                                                    <div>
                                                                                        <div className='font-40 font-bold font-fff'>Standards First Pacing Guide</div>
                                                                                        <div className='font-24 font-fff font-bold'>{standardDisplayName ? standardDisplayName : ''}</div>
                                                                                        <div>
                                                                                            <div className='font-24 p-2 pt-1 pb-1 br-4 mt-1 inline-block'
                                                                                                style={{ background: backgroundColor }}
                                                                                            ><span>{'Quarter ' + quarter}</span></div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div> : ''}
                                                            <div className='flex flex-v-center mt-4 pt-3 mb-05' id={'week-' + weekNumber}>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}><Icon type='calendar' style={{ fontSize: 24, color: '#2d6a9f' }} /><div style={{ fontSize: 24, fontWeight: 800, color: '#1e293b' }}>{'Quarter ' + quarter + ', Week ' + weekNumForQuarter}</div></div>
                                                            </div>
                                                            {this.props.pacingGuideBaseProps.currentWeek === weekNumber ?
                                                                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#ecfdf5', color: '#059669', border: '1px solid #a7f3d0', borderRadius: 999, padding: '6px 16px', fontSize: 16, fontWeight: 700, marginBottom: 12 }}><Icon type='clock-circle' /> This is the current week</div>
                                                                : ''}
                                                            {this.renderWeekConnection(weekNumber)}
                                                            <div style={{ marginBottom: 8 }}>
                                                                {week.map((item, index) => {
                                                                    return this.renderStandardCard(item, weekNumber, ind, index, weekNumForQuarter, isCurrentYear)
                                                                })}
                                                            </div>
                                                            {/*(this.props.pacingGuideBaseProps &&
                                                        this.props.pacingGuideBaseProps.assessmentsWeekDict &&
                                                        this.props.pacingGuideBaseProps.assessmentsWeekDict.hasOwnProperty(weekNumber) &&
                                                        this.props.pacingGuideBaseProps.assessmentsWeekDict[weekNumber].assessments)
                                                        ||
                                                        (this.props.pacingGuideBaseProps.hasOwnProperty('quizzesForEndWeek') &&
                                                            this.props.pacingGuideBaseProps.quizzesForEndWeek &&
                                                            this.props.pacingGuideBaseProps.quizzesForEndWeek.hasOwnProperty(weekNumber) &&
                                                            this.props.pacingGuideBaseProps.quizzesForEndWeek[weekNumber] &&
                                                            this.props.pacingGuideBaseProps.quizzesForEndWeek[weekNumber].length > 0) ?
                                                        <div className='mt-4'>
                                                            <div className='ant-shadow p-2 br-4 mb-2 background-light-grey-blue'>
                                                                {this.props.pacingGuideBaseProps &&
                                                                    this.props.pacingGuideBaseProps.assessmentsWeekDict &&
                                                                    this.props.pacingGuideBaseProps.assessmentsWeekDict.hasOwnProperty(weekNumber) &&
                                                                    this.props.pacingGuideBaseProps.assessmentsWeekDict[weekNumber].assessments ?
                                                                    <div>
                                                                        <div className='font-20 mb-05 font-bold'>
                                                                            {this.props.pacingGuideBaseProps.standardName === 'Kindergarten' ||
                                                                                this.props.pacingGuideBaseProps.standardName === '1st Grade' ?
                                                                                'Kindergarten and 1st Grade common assessments are coming soon.' :
                                                                                isBenchmark ? 'Benchmark' : 'Common assessments'}
                                                                        </div>
                                                                        {isBenchmark ?
                                                                            <div className='font-20 mb-2' style={{ maxWidth: '1100px' }}>
                                                                                The Benchmark questions are aligned with the standards of this quarter in the Pacing Guide.
                                                                            </div>
                                                                            :
                                                                            <div className='font-20 mb-2' style={{ maxWidth: '1100px' }}>
                                                                                The Common Assessment questions are aligned with the last three weeks of the Pacing Guide. Common Assessment Form A is given to the entire class. Common Assessment Form B can be given to individual students selected by the teacher as a retake.
                                                                            </div>
                                                                        }
                                                                    </div> : ''}
                                                                {this.props.pacingGuideBaseProps.hasOwnProperty('quizzesForEndWeek') &&
                                                                    this.props.pacingGuideBaseProps.quizzesForEndWeek &&
                                                                    this.props.pacingGuideBaseProps.quizzesForEndWeek.hasOwnProperty(weekNumber) &&
                                                                    this.props.pacingGuideBaseProps.quizzesForEndWeek[weekNumber] &&
                                                                    this.props.pacingGuideBaseProps.quizzesForEndWeek[weekNumber].length > 0 ?
                                                                    <div>
                                                                        <div className='font-20 mb-1 font-bold'>
                                                                            Assessments
                                                                        </div>
                                                                        <div>
                                                                            <Button className='lg-btn mb-2' type='primary'
                                                                                onClick={(e) => {
                                                                                    if (this.props.pacingGuideBaseProps.standardName === 'Kindergarten' ||
                                                                                        this.props.pacingGuideBaseProps.standardName === '1st Grade') {
                                                                                        this.setState({
                                                                                            k1CommonAssessmentModalVisible: true,
                                                                                        });
                                                                                    } else {
                                                                                        this.setState({
                                                                                            commonAssessmentModalVisible: true,
                                                                                        });
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <div className='flex flex-v-center'>
                                                                                    <Icon type='play-circle' className='mr-1 font-24' />
                                                                                    View Common Assessments Tutorial Video
                                                                                </div>
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                    : ''}
                                                                <div className='flex flex-wrap w-100'>
                                                                    {this.props.pacingGuideBaseProps.hasOwnProperty('quizzesForEndWeek') &&
                                                                        this.props.pacingGuideBaseProps.quizzesForEndWeek &&
                                                                        this.props.pacingGuideBaseProps.quizzesForEndWeek.hasOwnProperty(weekNumber) &&
                                                                        this.props.pacingGuideBaseProps.quizzesForEndWeek[weekNumber] &&
                                                                        this.props.pacingGuideBaseProps.quizzesForEndWeek[weekNumber].map((quiz, index) => {
                                                                            return <div className='mb-1 mr-1'>
                                                                                <PacingGuideAssessmentModalForm
                                                                                    assessment={quiz}
                                                                                    teacherBaseProps={this.props.teacherBaseProps}
                                                                                    buttonText={quiz.hasOwnProperty('assessmentTitle') ? quiz.assessmentTitle : 'Quiz'}
                                                                                    disableQuiz={false}
                                                                                    history={this.props.history}
                                                                                />
                                                                            </div>
                                                                        })}
                                                                </div>
                                                            </div>
                                                        </div> : ''*/}
                                                        </div>
                                                    })}
                                            </div>}
                                    </div>
                                </Content> : ''}
                        </Layout>
                    </Layout>
                    : ''}
            </div>
        )
    }
}
export default PacingGuideSC